import React from 'react';
import { Alert } from 'reactstrap';

import { formatDateString } from '~libs/dayjs';

import Icon, { faCalendar, faCircleCheck, faClock, faTriangleExclamation, IconProp } from '~components/icon';

import { ReviewDueState, reviewDueState } from '~clients/config/carePlanEnums';

interface ComponentProps {
  reviewDueDate?: string | null;
}

const STATE: Record<ReviewDueState, { color: string; icon: IconProp; label: (date: string) => string }> = {
  overdue: { color: 'danger', icon: faTriangleExclamation, label: (date) => `Review overdue, was due ${date}` },
  soon: { color: 'warning', icon: faClock, label: (date) => `Next review due ${date}` },
  future: { color: 'success', icon: faCircleCheck, label: (date) => `Next review due ${date}` },
  none: { color: 'info', icon: faCalendar, label: () => 'No review scheduled' },
};

/** Next-review-due banner: green (future), amber (within 30 days), red (overdue). */
const NextReviewBanner: React.FC<ComponentProps> = ({ reviewDueDate }) => {
  const state = reviewDueState(reviewDueDate);
  const { color, icon, label } = STATE[state];

  return (
    <Alert color={color} className="care-plan-alert" data-cy="care-plan-review-banner" data-state={state}>
      <Icon icon={icon} className="me-2" aria-hidden />
      {label(formatDateString(reviewDueDate))}
    </Alert>
  );
};

export default NextReviewBanner;
